<template>
  <div>

    <b-modal id="CouponUseDetail" size="lg" ref="CouponUseDetail" title="사용내역조회">
      <b-row class="text-center">
        <b-col cols="1"></b-col>
        <b-col cols="10">
          <b-table
            :fields="goodsType === 'MoneyCoupon' ? AmountFields : fields"
            head-variant="light"
            ref="general-table"
            class="vuetable"
            id="table-transition-example"
            :items="data"
            align="center"
          >
            <template v-slot:head(selected)>
              <b-form-checkbox ref="allchecked" v-model="chkAll" :checked="true" :unchecked-value="false"></b-form-checkbox>
            </template>
            <template v-slot:cell(selected)="row">
              <b-form-checkbox v-if="row.item.cancellable != false" v-model="row.item.selected" :checked="true" :unchecked-value="false"></b-form-checkbox>
            </template>
            <template v-slot:cell(use_amount)="row">
              {{row.item.use_amount | currency}}
            </template>
          </b-table>
        </b-col>
        <b-col cols="1"></b-col>
      </b-row>
      <template  slot="modal-footer">
        <b-button variant="primary" @click="couponCancel">사용취소</b-button>
        <b-button variant="outline-primary" @click="modalHide('CouponUseDetail')">닫기</b-button>
      </template>
    </b-modal>

    <b-modal id="cancelReason" size="lg" ref="cancelReason" title="사용취소신청">
      <b-row class="text-center">
        <b-col cols="2"></b-col>
        <b-col cols="8">
          <b-form-group label-cols="2" label="요청자">
            <b-form-input v-model="requester" placeholder="담당자 이름을 입력해 주세요."></b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" label="사유">
            <b-form-input v-model="reason" placeholder="취소 사유를 입력해 주세요."></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2"></b-col>
      </b-row>
      <template slot="modal-footer">
        <b-button variant="primary" @click="cancelProcess">확인</b-button>
        <b-button variant="outline-primary" @click="modalHide('cancelReason')">닫기</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import {currencyFilter, alignTableCenter} from "../../../utils";

  export default {
    name: "CouponUseDetail",
    props: ['data', 'goodsType'],
    filters: {...currencyFilter},
    data() {
      return {
        nocheckText: '',
        noBtns:'',
        chkAll: false,
        count : 0 ,
        requester : null ,
        reason : null,
        fields: [
          {key: 'selected', label: '', ...alignTableCenter},
          {key: 'use_date', label: '사용일', ...alignTableCenter},
          {key: 'use_store', label: '사용매장', ...alignTableCenter},
          {key: 'manager', label: '처리자', ...alignTableCenter},
        ],
        AmountFields: [
          {key: 'selected', label: '', ...alignTableCenter},
          {key: 'use_date', label: '사용일', ...alignTableCenter},
          {key: 'use_amount', label: '사용', ...alignTableCenter},
          {key: 'use_store', label: '사용매장', ...alignTableCenter},
          {key: 'manager', label: '처리자', ...alignTableCenter},
        ]
      }
    },
    created() {
    },
    watch: {
      chkAll(chk) {
        this.data.forEach((v) => {
          if(v.cancellable == false){
            v.selected = false;
          }else{
            v.selected = chk;
          }
          // console.log(this.data)
        })
      }
    },
    methods: {
      open() {

        this.$refs['CouponUseDetail'].show();
        this.chkAll = false;
      },
      modalHide(id) {
        this.$refs[id].hide()
      },
      couponCancel() {
        let selected = ''
        this.count = 0
        let tt =[];
        for (let i = 0; i < this.data.length; i++) {
          // console.log(this.data[i].cancellable)
          let st = this.data[i].cancellable;
          tt.push(st)
        }
        console.log(tt.indexOf(true));
        if(tt.indexOf(true) == 0){
            this.nodata = true;
        }else{
            this.nodata = false;
        }

        this.data.forEach((v,i) => {
          // if(v.selected)

          if (v.selected) {
            selected = true
            this.count++
          }
          if(this.nodata == false){
            this.nocheckText = "취소 가능 기간이 경과되었습니다. 테이블엔조이 고객센터로 문의해 주세요 (1600-3662)"
          }else{
            this.nocheckText = "취소처리 하실 내역을 선택해주세요.";
          }
        })
        if (!selected) {
          alert(this.nocheckText)
          return false
        }

        this.requester = null
        this.reason = null
        this.$refs['cancelReason'].show()
      },
      cancelProcess() {
        if( this.requester === null || this.requester === "" ) {
          alert('요청자 이름을 입력해 주세요.')
          return false
        } else if ( this.reason === null || this.reason === "" ) {
          alert('취소 사유를 입력해 주세요.')
          return false
        } else {
          if( confirm(this.count + '건을 취소하시겠습니까? ')) {

            this.$emit('process' ,{
              cancelReason : this.reason,
              requester : this.requester,
              cancelUsed : this.data
            })
          }
        }
      }
    }
  }
</script>
